





































































































































































































import _ from "lodash";

import { Watch, Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation, State } from "vuex-class";
import { Maintenancejob, Customer } from "@/models";
import { MaintenancejobsState } from "@/store/maintenancejobs/types";
import QuotationEmailModal from "../../components/modals/QuotationEmailModal.vue";
import ProgressButton from "@/components/ProgressButton.vue";

@Component({
  components: {
    QuotationEmailModal,
    ProgressButton,
  }
})
export default class JobList extends Vue {
  @State("maintenancejobs") public maintenancejobsState: MaintenancejobsState;

  @Getter("app/hasBlockingRequests") public hasBlockingRequests: boolean;
  @Getter("maintenancejobs/list") public list: Maintenancejob[];
  @Action("customers/getCustomers") getCustomers: () => Promise<void>;
  @Action("contractors/getContractors") getContractors: () => Promise<void>;


  @Action("maintenancejobs/getMaintenancejobs")
  getMaintenancejobs: () => Promise<void>;
  @Action("maintenancejobs/setSearch")
  public setSearch: (search: string) => Promise<any>;
  @Action("maintenancejobs/setFilterCustomer")
  public setFilterCustomer: (customer: string) => Promise<any>;
  @Action("maintenancejobs/setFilterContractor")
  public setFilterContractor: (customer: string) => Promise<any>;
  @Action("maintenancejobs/setFilterStatus")
  public setFilterStatus: (status: string) => Promise<any>;
  @Mutation("maintenancejobs/setCurrent")
  public setCurrent: (maintenancejob: Maintenancejob) => void;
  @Mutation("app/removeRequest")
  public removeRequest: (id: string) => void;

  @Getter("contractors/list") public contractorslist: Customer[];
  public contractorsOptions: { value: string; label: string }[] = [];
  @Getter("customers/list") public customerlist: Customer[];
  public customerOptions: { value: string; label: string }[] = [];
  @Action("maintenancejobs/deleteMaintenancejob") deleteStoreMaintenancejob: (
    maintenancejob: Maintenancejob
  ) => Promise<void>;
  @Action("maintenancejobs/generateMaintenancejobPdf") 
  generateMaintenancejobPdf: (payload: {maintenancejob: Maintenancejob, downloadType: string}) => Promise<any>;
  public qry = {};

  public async mounted() {
    if (this.customerlist.length == 0) {
      await Promise.all([this.getCustomers()])
        .then(() => {
          this.setCustomerOptions();
        })
        .catch((err: any) => this.$onecentral.displayError(err));
    } else {
      this.setCustomerOptions();
    }
    if (this.contractorslist.length == 0) {
      await Promise.all([this.getContractors()])
        .then(() => {
          this.setContractorOptions();
        })
        .catch((err: any) => this.$onecentral.displayError(err));
    } else {
      this.setContractorOptions();
    }
  }

  public async setCustomerOptions() {
    this.customerOptions = Array.from(this.customerlist).map(b => ({
      value: b.id,
      label: b.companyName
    }));
  }
  public async setContractorOptions() {
    this.contractorsOptions = Array.from(this.contractorslist).map(b => ({
      value: b.id,
      label: b.companyName
    }));
  }

  get search(): string | undefined {
    return this.maintenancejobsState.search;
  }
  set search(val: string | undefined) {
    this.setSearch(val ? val : "");
  }

  // Watch for when the "filtercustomer" query param changes...
  @Watch("$route.query.filtercustomer")
  public onCustomerChange(val: string, oldVal: string) {
    if (val) {
      this.setFilterCustomer(val).then(() => this.getMaintenancejobs());
    }
  }
  // Watch for when the "filtercontractor" query param changes...
  @Watch("$route.query.filtercontractor")
  public onContractorChange(val: string, oldVal: string) {
    if (val) {
      this.setFilterContractor(val).then(() => this.getMaintenancejobs());
    }
  }
  // ...and also when the "search" query param changes
  @Watch("$route.query.search")
  public onSearchChanged(val: string, oldVal: string) {
    if (val) {
      this.setSearch(val).then(() => this.getMaintenancejobs());
    }
  }
  // Watch for when the "filterStatus" query param changes...
  @Watch("$route.query.filterStatus")
  public onStatusChange(val: string) {
    if (val) {
      this.setFilterStatus(val).then(() => this.getMaintenancejobs());
    }
  }

  public editMaintenancejob(maintenancejob: Maintenancejob): void {
    this.setCurrent(maintenancejob);
    this.$router.push({
      name: "edit-maintenancejob",
      params: { id: maintenancejob.id || "" }
    });
  }

  public onCustomerSelect(selected: any) {
    if (selected !== null) {
      this.query.filtercustomer = selected.value;
      this.$router.push({ path: "maintenancejobs", query: this.query });
    }
  }

  public onContractorSelect(selected: any) {
    if (selected !== null) {
      this.query.filtercontractor = selected.value;
      this.$router.push({ path: "maintenancejobs", query: this.query });
    }
  }

  public onStatusSelect(selected: any) {
    if (selected !== null) {
      this.query.filterStatus = selected;
      this.$router.push({ path: "maintenancejobs", query: this.query });
    }
  }

  public clearCustomerfilter() {
    this.setFilterCustomer("");
    this.query.filtercustomer = undefined;
    this.$router.push({ path: "maintenancejobs", query: this.query });
    this.getMaintenancejobs();
  }
  public clearContractorfilter() {
    this.setFilterContractor("");
    this.query.filtercontractor = undefined;
    this.$router.push({ path: "maintenancejobs", query: this.query });
    this.getMaintenancejobs();
  }

  public clearStatusfilter() {
    this.setFilterStatus("");
    this.query.filterStatus = undefined;
    this.$router.push({ path: "maintenancejobs", query: this.query });
    this.getMaintenancejobs();
  }

  public deleteMaintenancejob(maintenancejob: Maintenancejob): void {
    this.$onecentral
      .confirmPrompt()
      .then(() => this.deleteStoreMaintenancejob(maintenancejob))
      .then(() => Vue.toasted.success("Maintenancejob deleted"))
      .catch((err: any) => this.$onecentral.displayError(err));
  }

  public created(): void {
    if (this.maintenancejobsState.filterCustomer) {
      this.$router.push({
        path: "maintenancejobs",
        query: { customer: this.maintenancejobsState.filterCustomer }
      });
    } else if (this.maintenancejobsState.filterStatus) {
      this.$router.push({
        path: "maintenancejobs",
        query: { status: this.maintenancejobsState.filterStatus }
      });
    } else if (this.maintenancejobsState.search) {
      this.$router.push({
        path: "maintenancejobs",
        query: { search: this.maintenancejobsState.search }
      });
    } else if (this.maintenancejobsState.filterContractor) {
      this.$router.push({
        path: "maintenancejobs",
        query: { search: this.maintenancejobsState.filterContractor }
      });
    } else {
      this.getMaintenancejobs();
    }
  }

  get filtercustomer(): { value: string; label: string } | undefined {
    return this.customerOptions.find((x: { value: string; label: string }) => {
      return x.value === this.maintenancejobsState.filterCustomer;
    });
  }
  get filtercontractor(): { value: string; label: string } | undefined {
    return this.contractorsOptions.find((x: { value: string; label: string }) => {
      return x.value === this.maintenancejobsState.filterContractor;
    });
  }


  get filterStatus() {
    return this.maintenancejobsState.filterStatus;
  }

  /**
   * Search through maintenancejobs by string
   */
  public onSubmit() {
    this.query.search = this.search;
    this.$router.push({ path: "maintenancejobs", query: this.query });
  }

  get query() {
    return this.qry;
  }
  set query(val: any) {
    this.qry = val;
  }

  public statusOptions: string[] = [
    "New",
    "Unallocated",
    "Allocated",
    "In Progress",
    "On Hold",
    "Completed"
  ];

  public showEmailReportDialog(maintenancejob: Maintenancejob) {
    let modal: any = this.$refs.quotationEmailModal as any;
    modal.init(maintenancejob);
    document.body.appendChild(modal.$el);
    ($(modal.$el) as any).modal("show");
  }

  /**
   * Go to selected report
   *
   * @param {Maintenancejob}
   */
  public gotoViewEmaiMaintenanceJobHistory(
    maintenancejob: Maintenancejob
  ): void {
    this.$router.push({
      name: "viewemailmaintenancejobhistory",
      params: { id: maintenancejob.id || "" }
    });
  }

  /**
   * Download Maintenancejob/Invoice/Proforma PDF
   *
   * @param {Maintenancejob} maintenancejob
   * @param {String} downloadType
   */
   public generatePdf(maintenancejob: Maintenancejob, downloadType: string, requestId: string): void {
    this.generateMaintenancejobPdf({ maintenancejob, downloadType })
      .then((key: string) => {
        this.$onecentral.downloadAttachment(key);
        this.$toasted.success(`${downloadType} for ${maintenancejob.ref} PDF downloaded`);
      })
      .finally(() => this.removeRequest(requestId))
      .catch((err: any) => this.$onecentral.displayError(err));
  }
}
